module.exports = __webpack_public_path__ + "assets/img/headerImg-1.cf86c2f4.jpg";